// material-ui
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { alpha } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import Stack from '@mui/material/Stack';
// types
import LogoSection from '../LogoSection';
import nemologo from 'assets/images/nemo-logo.png';
import footergaming from 'assets/images/footer-gaming-logo.svg';
import pagcorgaming from 'assets/images/PAGCORLogo.svg';
import FacebookIcon from 'assets/images/facebookicon.jpg';
import { useEffect, useState } from 'react';

const StyledFooterMain = styled(Box)(({ theme }) => ({
    borderBottom: '1px dotted rgba(165, 176, 189, 0.2)',
    borderTop: '4px solid ',
    padding: '12px 16px',
    borderTopColor: alpha(theme.palette.secondary.main, 1)
}));

const StyledFooterContainer = styled(Box)(({ theme }) => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex !important',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column'
    }
}));

const StyledFooterLogo = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    '.footerlogo': {
        img: {
            width: ' 160px'
        }
    },
    '.nemologoview': {
        borderLeft: '1px solid #595959',
        paddingLeft: '15px',
        marginLeft: '15px'
    },
    '.nemologo': {
        width: '90px'
    }
}));

const StyledFooter = styled(Box)(({ theme }) => ({}));

const StyledFooterSupport = styled(Box)(({ theme }) => ({
    alignItems: 'center',
    background: '#1c1c1c',
    flexDirection: 'column',
    display: 'flex !important',
    justifyContent: 'center',
    padding: '22px 0 16px',
    p: {
        color: '#b5b5b5',
        fontSize: '14px',
        lineHeight: '20px',
        margin: '0px'
    },
    a: {
        color: '#b5b5b5 !important',
        fontSize: '13px',
        textDecoration: 'underline',
        transition: 'color 0.3s'
    }
}));

const StyledFooterPartnered = styled(Box)(({ theme }) => ({
    ul: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        listStyle: 'none',
        [theme.breakpoints.down('sm')]: {}
    },
    img: {
        transition: ' opacity 0.3s',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    [theme.breakpoints.down('sm')]: {
        marginBottom: '20px',
        marginTop: '20px'
    }
}));

const StyledFooterSocialMedia = styled(Box)(({ theme }) => ({
    ul: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        listStyle: 'none'
    },
    'a:hover': {
        svg: {
            path: {}
        }
    },
    svg: {
        overflow: 'hidden'
    },
    'img,svg': {
        verticalAlign: 'middle'
    },
    'svg path ': {
        fill: '#e1e7ed',
        transition: 'all .3s'
    }
}));

const StyledFooterMenu = styled(Box)(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 16px'
}));

const StyledFooterMenuWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column'
    }
}));

const StyledFooterMenuListContainer = styled(Box)(({ theme }) => ({
    ul: {
        display: 'flex ',
        listStyle: 'none',
        paddingLeft: '0px',
        [theme.breakpoints.down('sm')]: {
            display: ' initial !important',
            float: 'left',
            width: '100%',
            textAlign: 'center',
            margin: '0px auto'
        }
    },
    li: {
        active: { color: '#ffff' }
    },
    'li a': {
        borderRight: '1px solid #595959',
        color: '#b5b5b5',
        fontSize: '14px',
        marginRight: '12px',
        paddingRight: '12px',
        textDecoration: 'none',
        transition: 'color 0.3s',
        '&:hover': {
            color: '#fff'
        }
    },
    [theme.breakpoints.down('sm')]: {
        ul: {
            float: 'left',
            width: '100%',
            display: 'initial !important',
            textAlign: 'center',
            margin: '0px auto'
        },
        li: {
            display: 'inline-block',
            marginBottom: '7px',
            width: 'auto',
            '&:last-child': {
                a: {
                    borderRight: '0px !important'
                }
            }
        },
        a: {
            fontSize: '12px !important',
            marginRight: '10px !important',
            paddingRight: '10px !important',
            float: 'left'
        }
    }
}));

const StyledFooterCopyRight = styled(Box)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        p: { textAlign: 'center' }
    }
}));

const Footer = () => {
    const THEME = import.meta.env.VITE_APP_USE_THEME;
    const [isFairPlay, setIsFairPlay] = useState(false);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const hostname = window.location.hostname;
            setIsFairPlay(hostname === 'www.fairplay.ph' || hostname === 'fairplay.ph');
        }
    }, []);
    return (
        <Box>
            <StyledFooter style={{ marginTop: '30px' }} className="footer">
                {isFairPlay && (
                    <Stack
                        sx={{
                            position: 'fixed',
                            right: '20px',
                            bottom: '100px',
                            zIndex: '9999',
                            background: '#fff',
                            borderRadius: '100%',
                            width: '60px',
                            height: '60px',
                            textAlign: 'center',
                            alignItems: 'center',
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <Link href="https://www.facebook.com/share/1GP8PwhiLz/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                            <img src={FacebookIcon} alt="Face-Book" width="40px" />
                        </Link>
                    </Stack>
                )}
                <StyledFooterSupport>
                    <p>
                        We greatly appreciate your feedback! The dedicated {THEME.toUpperCase()} team is available around the clock to
                        assist you. Don&apos;t hesitate to contact us, and we assure you a prompt response.
                    </p>

                    <p>
                        {isFairPlay ? (
                            <>
                                For any questions contact us at{' '}
                                <Link
                                    href="https://www.facebook.com/share/1GP8PwhiLz/?mibextid=wwXIfr"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    click here to visit our Facebook page
                                </Link>
                            </>
                        ) : (
                            <>
                                For any questions or queries email us at <Link href="mailto:support@nemo-ig.com">support@nemo-ig.com</Link>{' '}
                                <br />
                                For support, please contact +919999999999.
                            </>
                        )}
                    </p>
                    {/* <p>
                        For any questions or queries email us at <Link href={`mailto:csr@nemo-ig.com`}>csr@nemo-ig.com</Link> <br />
                        For support, please contact +639613970012 or +639613651865.
                    </p> */}
                </StyledFooterSupport>
                <StyledFooterMain>
                    <StyledFooterContainer>
                        <StyledFooterLogo>
                            <Link className="footerlogo">
                                <LogoSection />
                                {/* <img src={ArionPlayLogo} alt="nemo" className="" /> */}
                            </Link>
                            <Link aria-label="footer_logo" className="nemologoview">
                                <img src={nemologo} alt="nemo" className="nemologo" />
                            </Link>
                        </StyledFooterLogo>
                        <StyledFooterPartnered>
                            <ul style={{ padding: '0px', margin: '0px' }} className="flex social_media">
                                <li>
                                    <Link target="_new" aria-label="pagcor-link">
                                        {/* <img src="/icons/partners/footer-gaming-logo.svg" alt="" />
                                        <img src={pagcorgaming} alt="footer-gaming-logo" /> */}

                                        <img
                                            src={footergaming}
                                            alt="footer-gaming-logo"
                                            // style={{ width: '180px', height: 'auto' }} // adjust as needed
                                        />
                                    </Link>
                                </li>
                            </ul>
                        </StyledFooterPartnered>
                        <StyledFooterSocialMedia>
                            <ul className="flex social_media" style={{ minWidth: 200 }}></ul>
                        </StyledFooterSocialMedia>
                    </StyledFooterContainer>
                </StyledFooterMain>
                <StyledFooterMenu>
                    <StyledFooterMenuWrapper>
                        <StyledFooterMenuListContainer>
                            <ul className="flex footer_menu">
                                <li>
                                    <Link to="/terms" aria-label="" component={RouterLink}>
                                        Terms &amp; Conditions
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/locations" aria-label="" component={RouterLink}>
                                        Locations
                                    </Link>
                                </li>

                                <li>
                                    <Link aria-label="" component={RouterLink} to="/betrules">
                                        Play Rules
                                    </Link>
                                </li>
                                <li>
                                    <Link aria-label="" to="/responsiblegaming" component={RouterLink}>
                                        Responsible Gaming
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/privacypolicy" aria-label="" component={RouterLink}>
                                        Privacy Policy
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/aboutus" aria-label="" component={RouterLink}>
                                        About Us
                                    </Link>
                                </li>
                                <li>
                                    <Link aria-label="" to="/contactus" component={RouterLink}>
                                        Contact Us
                                    </Link>
                                </li>
                                <li>
                                    <Link aria-label="" to="/faqs" component={RouterLink}>
                                        FAQs &amp; Help
                                    </Link>
                                </li>
                            </ul>
                        </StyledFooterMenuListContainer>
                        <StyledFooterCopyRight>
                            <p>
                                <span>&#169;</span> 2025 All Rights Reserved.
                            </p>
                        </StyledFooterCopyRight>
                    </StyledFooterMenuWrapper>
                </StyledFooterMenu>
            </StyledFooter>
        </Box>
    );
};

export default Footer;
